import './DraggableDimensionValue.scss';
import {RowColConfig} from "@/components/DodConfigEditor/types";
import {Draggable} from "react-beautiful-dnd";
import classnames from "classnames";
import React, { ReactNode, useMemo } from "react";
import Tippy from '@tippyjs/react';

interface DraggableDimensionValueProps {
    className?: string;
    label: string;
    index: number;
    mode?: string|null;

    onConfigChange?(config: RowColConfig): void;
}

const baseClassName = 'draggable-dimension-value';

export function DraggableDimensionValue({
                                            className,
                                            label,
                                            index,
                                            onConfigChange,
                                            mode,
                                            ...props
                                        }: DraggableDimensionValueProps) {
    const isApplyNewLayoutMode = mode === 'layout';
    const applyNewLayoutDisabledTip = useMemo<ReactNode | undefined>(() => {
            if (mode === 'layout') {
                return <>
                    <p>This selection type is not currently compatible with Apply New Layout.
                    Please use the modify option if you wish to change this aspect of your layout.</p>                
                </>
            }        
        }, [mode]);

    return (
        <Draggable isDragDisabled={isApplyNewLayoutMode ? true : false} draggableId={label} index={index}>
            {(provided, snapshot) => (
                <div
                    className={classnames(baseClassName, className)}
                    {...props}
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                >
                    {isApplyNewLayoutMode ? (
                        <>
                            <Tippy content={isApplyNewLayoutMode && applyNewLayoutDisabledTip}>
                                <i className={`${baseClassName}__dnd-handle--disabled`} />
                            </Tippy>{' '}
                            <h1 className={`${baseClassName}__label--disabled`}>{label}</h1>{' '}
                        </>
                    ) : (
                        <>
                            {' '}
                            <i className={`${baseClassName}__dnd-handle`} />{' '}
                            <h1 className={`${baseClassName}__label`}>{label}</h1>{' '}
                        </>
                    )}
                </div>
            )}
        </Draggable>
    );
}
